module.exports = __webpack_public_path__ + "static/media/IMG_1671.d99d7135.JPG";